import Vue from 'vue'

const client = () => Vue.prototype.$api

export default {
    notifyProfessionalDisabledTarifaPlus (params) {
        return client().post('professionals/NotifyProfessionalDisabledTarifaPlus', params)
    },
    notifyPrevalidatedProfessional (params) {
        return client().post('professionals/NotifyProfessionalPrevalidated', params)
    },
    getProfPatients (name) {
      return client().get('professionals/GetProfessionalPatients', { params: { name: name } })
    }
}


// WEBPACK FOOTER //
// ./src/repositories/ProfessionalRepository.js